export default class StorableImageError extends Error {
    constructor(...params) {
        super(...params);
        this.name = 'StorableImageError';
    }
}
